import PropTypes from 'prop-types';

export const collectionActionShape = PropTypes.shape({
	key: PropTypes.string.isRequired,
	icon: PropTypes.elementType.isRequired,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	danger: PropTypes.bool,
	disabled: PropTypes.bool,
});

export const collectionStatShape = PropTypes.shape({
	value: PropTypes.number,
	label: PropTypes.string.isRequired,
});

export const collectionTagShape = PropTypes.shape({
	label: PropTypes.string.isRequired,
	prefix: PropTypes.string,
	tone: PropTypes.string,
});

export const collectionDateShape = PropTypes.shape({
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
});

/**
 * Feature-agnostic description of one collection entry; rows and tiles render the same shape.
 * `onRename` receives the trimmed new name and must return a promise — it adds the pencil action.
 * `date.value` is an ISO string, `stats[].value` is rendered bold before its label when present.
 */
export const collectionItemShape = PropTypes.shape({
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	onOpen: PropTypes.func,
	onRename: PropTypes.func,
	stats: PropTypes.arrayOf(collectionStatShape),
	tags: PropTypes.arrayOf(collectionTagShape),
	date: collectionDateShape,
	actions: PropTypes.arrayOf(collectionActionShape),
});
